document.addEventListener('alpine:init', () => {

      Alpine.data('RebateContent', () => ({
        product: null,
        is_rebate: null,
        variant_title: null,
        variant_comp: null,
        variant_price: null,
        variant_sale: null,
  
        mounted() {
          let am = this;
          console.log('mounted rebate content');
          am.LoadProduct();
  
          subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
            console.log('variant change', e.data.variant);
            let variant_id = e.data.variant.id.toString();
  
            am.product.selected_variant = am.product.variants.find(v => v.id == variant_id);
            if (!am.product.selected_variant) {
              console.error('No selected variant found');
              return;
            }
  
            am.SetRebateContent();
          });
        },
  
        LoadProduct() {
          let am = this;
          UTILS.ConvertStringToJS(am.$el.querySelector('[data-rebates-json]').innerHTML);
          if (!product) {
            console.error('Product object not found');
            return;
          }
  
          am.product = product;
          console.log('Loaded product:', product);
          am.SetRebateContent();
        },
  
        SetRebateContent() {
          let am = this;
          if (!am.product || !am.product.selected_variant) {
            console.error('Product or selected variant is not defined');
            return;
          }
  
          let selectedVariant = am.product.selected_variant;
          am.is_rebate = selectedVariant.is_rebate || false;
          am.variant_title = selectedVariant.title || 'Unknown Title';
          am.variant_comp = selectedVariant.compare_price || 0;
          am.variant_price = selectedVariant.price || 0;
          am.variant_sale = selectedVariant.sale || 0;
  
          // console.log({
          //   is_rebate: am.is_rebate,
          //   variant_title: am.variant_title,
          //   variant_comp: am.variant_comp,
          //   variant_price: am.variant_price,
          //   variant_sale: am.variant_sale
          // });
        },
      }));

  
  console.log('alpine:init');
  Alpine.data('productDescription', () => ({
      expanded: false,
      truncated: true,
      fullDescription: '',
      truncatedDescription: '',
      toggle() {
          this.expanded = !this.expanded;
          this.truncated = !this.truncated;
          if (this.expanded) {
              this.scrollToTop();
          }
      },
      init() {
          const descriptionElement = this.$refs.descriptionContainer;
          this.fullDescription = descriptionElement.innerHTML;

          // Create a temporary div to extract text
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = this.fullDescription;

          // Select only <p> tags
          const paragraphs = tempDiv.querySelectorAll('p');
          const paragraphTexts = Array.from(paragraphs).map(p => p.innerText || p.textContent).join(' ');

          // Set truncated description
          if (paragraphTexts.length > 400) {
            console.log('truncating')
              this.truncatedDescription = paragraphTexts.slice(0, 310) + '...';
          } else {
            console.log('not truncating')
              this.truncatedDescription = paragraphTexts;
              this.truncated = false;
              this.expanded = true;
          }
      },
      scrollToTop() {
          const descriptionContainer = this.$refs.descriptionContainer;
          descriptionContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
  }));
  Alpine.data('ListProducts', () => ({
    init() {
      // console.log('ListProducts');
      let $list = this.$el;
      const $items = Array.from($list.querySelectorAll("li"));

      // sort items by data-is_priority attribute
      $list.append(...$items.sort(($a, $b) => $a.dataset.is_priority === 'true' ? -1 : 1));

      this.$el.removeAttribute('x-cloak-op');
    },
  }));

     

  

  Alpine.data('SearchProducts', () => ({
    cache: {},
    loaded: false,
    search_products: [],
    limit: 10,
    init() {
      this.InitCache();
      this.SearchProducts();
    },
    InitCache() {
      let am = this;
      am.cache.$form = am.$el.closest('form');
      am.cache.$input = am.cache.$form.querySelector('.search__input');
    },
    async SearchProducts() {
      let am = this;
      let searchTerm = am.cache.$input.value;
      // additional searches
      // 1. search for products only 
      let results_search_products = await Promise.all([
        fetch(`${routes.predictive_search_url}.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`).then(res => res.json())
      ]);
      // console.log(results_search_products)

      let search_products = results_search_products.flatMap(item => item.resources.results.products).slice(0, am.limit);
      // remove duplicates
      let handles = [...new Set(search_products.map(item => item.handle))];
      let products = [];
      handles.forEach((handle) => {
        products.push(search_products.find(item => item.handle == handle));
      });
      am.loaded = true;
      am.search_products = products;
    }
  }));
});
function levenshtein(a, b) {
  const matrix = [];

  // Create a matrix of size (a.length + 1) x (b.length + 1)
  for (let i = 0; i <= a.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= b.length; j++) {
    matrix[0][j] = j;
  }

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      if (a.charAt(i - 1) === b.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          Math.min(
            matrix[i][j - 1] + 1, // insertion
            matrix[i - 1][j] + 1 // deletion
          )
        );
      }
    }
  }
  return matrix[a.length][b.length];
}

function isFuzzyMatch(vendor, searchText) {
  const threshold = 2; // Maximum distance for a match
  return levenshtein(vendor, searchText) <= threshold;
}

class brandIndex extends HTMLElement {
  constructor() {
    super();
    this.search = this.querySelectorAll('[id^="brand-index-"]'); 
    if (!this.search) return;
    this.initSearch();
  }

  initSearch() {
    console.log('search running');
    var list = this.querySelectorAll('.vendor');
    var groups = this.querySelectorAll('.vendor-group');
    this.search.forEach(function(element) {
      element.addEventListener('keyup', function() {
        var text = this.value.toUpperCase();
        for (var i = 0; i < list.length; i++) {
          var vendorName = list[i].innerText.toUpperCase();
          if (vendorName.includes(text) || isFuzzyMatch(vendorName, text)) {
            list[i].style.display = 'block';
          } else {
            list[i].style.display = 'none';
          }
        }
        // Now, check each vendor group to see if it has any visible vendors
        for (var j = 0; j < groups.length; j++) {
          var vendorsInGroup = groups[j].querySelectorAll('.vendor');
          var groupVisible = Array.from(vendorsInGroup).some(vendor => vendor.style.display !== 'none');

          if (groupVisible) {
            groups[j].style.display = 'flex'; // Show group if it has visible vendors
          } else {
            groups[j].style.display = 'none'; // Hide group if no vendors are visible
          }
        }
      });
    });
  }
}
customElements.define('brand-index', brandIndex);


class RebatesModal extends DetailsModal {
  constructor() {
    super();

    
  }
}

customElements.define('rebates-modal', RebatesModal);



// dots for deals in main nav and pop up for build your kit
document.addEventListener("DOMContentLoaded", function() {
    // const popup = document.querySelector('[data-popup]');
    // const trigger = document.querySelector('[data-popup-open]');
    // const closeBtn = document.querySelector('[data-popup-close]');
    // if (trigger && popup){
    //   console.log('found trigger and pop up')
    //   // Open popup
    //   trigger.addEventListener('click', () => {
    //     popup.classList.remove('modal--hidden');
    //   });
    
    //   // Close popup
    //   closeBtn.addEventListener('click', () => {
    //     popup.classList.add('modal--hidden');
    //   });
    
    //   // Close on outside click
    //   popup.addEventListener('click', (event) => {
    //     if (event.target === popup) {
    //       popup.classList.add('modal--hidden');
    //     }
    //   });
    // }

  // tabs function on rebate builder
    const tabs = document.querySelectorAll('.tabset input[name="kit-tabset"]');
    const panels = document.querySelectorAll('.tab-panel-rebate');
  
    // Hide all panels by default
    const hideAllPanels = () => {
      panels.forEach(panel => panel.style.display = 'none');
    };
  
    // Show the panel associated with the selected tab
    const showPanel = (tab) => {
      const panelId = tab.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (panel) {
        panel.style.display = 'block';
      }
    };
  
    // Add event listeners to the tabs
    tabs.forEach(tab => {
      tab.addEventListener('change', function () {
        hideAllPanels();
        showPanel(tab);
      });
    });
  
    // Initialize: Show the panel for the checked tab
    const initialTab = document.querySelector('.tabset input[name="kit-tabset"]:checked');
    if (initialTab) {
      showPanel(initialTab);
    }
  
  // Function to set a cookie
  function setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + d.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  // Function to get a cookie value
  function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
  }

  // Get all cross--item elements
  const items = document.querySelectorAll('.cross--item');

  items.forEach(item => {
      const startDate = new Date(item.getAttribute('data-start-date'));
      const link = item.closest('a');

      // Check if the link is valid
      if (link) {
          const linkHref = link.href;
          const visitedCookie = getCookie(linkHref);

          // If visited and the date has passed, hide the dot
          if (visitedCookie && new Date() > startDate) {
              const dot = item.querySelector('.dot');
              if (dot) {
                  dot.style.display = 'none'; // Hides the dot
              }
          }

          // Set a click event to mark the link as visited
          link.addEventListener('click', function() {
              setCookie(linkHref, 'visited', 7); // Store cookie for 7 days
          });
      }
  });

  const parentDot = document.querySelector('#deals-trigger');
  // Hide special-dot when parentDot is clicked
  if (parentDot) {
    parentDot.addEventListener('click', function() {
        setCookie('hideSpecialDotxx', 'true', 1); // Store cookie for 1 days
        const specialDots = document.querySelectorAll('.parent-dot');
        specialDots.forEach(dot => {
            dot.style.display = 'none'; // Hides the special dots
        });
    });
  }

  // Check if the special-dot should be hidden
  if (getCookie('hideSpecialDotxx') === 'true') {
      const specialDots = document.querySelectorAll('.parent-dot');
      specialDots.forEach(dot => {
          dot.style.display = 'none'; // Hides the special dots if cookie exists
      });
  } else {
    const specialDots = document.querySelectorAll('.parent-dot');
      specialDots.forEach(dot => {
          dot.style.display = 'inline-block'; //Show special dot
      });
  }

});

